export default __webpack_public_path__ + "static/media/IMG_7046.09d7e9c3.jpg";